export const INPUT_SIZE_MAP = {
	DEFAULT: `input f5 theme-luxury:px-4! theme-luxury:text-base!`,
	SMALL: `input-small f6 theme-luxury:py-[7px]! theme-luxury:px-4! theme-luxury:text-base!`,
	LARGE: `input-large f5 theme-luxury:py-[17.5px]! theme-luxury:px-6!`
};

export type InputSize = keyof typeof INPUT_SIZE_MAP;

export type InputMode = 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
